import React from "react";
import styled from "styled-components";
import { keyframes } from "styled-components";

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  background-color: rgba(0, 0, 0);
`;

const LoadingAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const LoadingCircle = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: 3px solid #fff;
  border-top-color: #3885fd;
  animation: ${LoadingAnimation} 1s linear infinite;
`;

const Loading = () => {
  return (
    <LoadingContainer>
      <LoadingCircle />
    </LoadingContainer>
  );
};

export default Loading;
